<template>
  <div>
    <validation-observer
      ref="docContentRules"
      #default="{ invalid }"
    >
      <b-form
        class="position-relative"
      >
        <b-row>
          <b-col md="12">
            <b-alert
              v-if="errorMsg"
              variant="danger"
              show
            >
              <div class="alert-body">
                <span>{{ errorMsg }}</span>
              </div>
            </b-alert>
            <b-card
              border-variant="success"
              bg-variant="transparent"
              class="shadow-none module-card"
            >
              <b-overlay
                :show="busy"
                rounded="lg"
                opacity="0.6"
              >
                <b-form-group>
                  <b-form-checkbox
                    v-model="isTimed"
                    class="custom-control-primary"
                    name="checkbox-timed"
                  >
                    {{ $t('DEBTIA_TIMED') }}
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  v-if="isTimed"
                  :label="$t('DEBTIA_NUMBER_OF_DAYS')"
                  :label-for="'number-of-days'"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('DEBTIA_NUMBER_OF_DAYS')"
                    rules="required|integer|nonNegative|min_value:1"
                  >
                    <b-form-input
                      :id="'number-of-days'"
                      v-model="numberOfDays"
                      :state="errors.length > 0 ? false : null"
                      type="number"
                      :placeholder="$t('DEBTIA_NUMBER_OF_DAYS')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <hr>

                <div
                  v-for="(row, index) in conditionRows"
                  :key="row.id"
                  class="condition-row border rounded p-2 mb-2"
                >
                  <b-row class="align-items-start">
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-1 mb-md-0"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="`fileCategory-${index}`"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_FILE_CATEGORIES')"
                          :label-for="`file-category-${index}`"
                          class="mb-0"
                        >
                          <v-select
                            v-model="row.fileCategory"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="availableFileCategories(index)"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="`file-category-${index}`"
                          />
                          <small
                            class="text-danger"
                            style="min-height: 18px;"
                          >{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col
                      cols="12"
                      md="3"
                      class="mb-1 mb-md-0"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="`operator-${index}`"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_OPERATOR')"
                          :label-for="`operator-${index}`"
                          class="mb-0"
                        >
                          <v-select
                            v-model="row.operator"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="operatorOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="`operator-${index}`"
                          />
                          <small
                            class="text-danger"
                            style="min-height: 18px;"
                          >{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col
                      cols="12"
                      md="4"
                      class="mb-1 mb-md-0"
                    >
                      <validation-provider
                        #default="{ errors }"
                        :name="`customField-${index}`"
                        rules="required"
                      >
                        <b-form-group
                          :label="$t('DEBTIA_CUSTOM_FIELD')"
                          :label-for="`custom-field-${index}`"
                          class="mb-0"
                        >
                          <v-select
                            v-model="row.customField"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="customVariableOptions"
                            :reduce="val => val.value"
                            :clearable="false"
                            :input-id="`custom-field-${index}`"
                          />
                          <small
                            class="text-danger"
                            style="min-height: 18px;"
                          >{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                    <b-col
                      cols="12"
                      md="1"
                      class="d-flex justify-content-end justify-content-md-center mt-2 mt-md-2"
                    >
                      <b-button
                        v-if="conditionRows.length > 1 && index !== 0"
                        variant="gradient-danger"
                        class="rounded-circle btn-icon"
                        size="sm"
                        @click.prevent="removeRow(index)"
                      >
                        <feather-icon icon="Trash2Icon" />
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row
                    v-if="row.customField === 'literal'"
                    class="mt-1"
                  >
                    <b-col
                      cols="12"
                      md="12"
                    >
                      <b-form-group
                        :label="$t('DEBTIA_ADD_CUSTOM_NUMBER')"
                        :label-for="`custom-number-${index}`"
                        class="mb-0"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :name="`customNumber-${index}`"
                          rules="required|integer|nonNegative"
                        >
                          <b-form-input
                            :id="`custom-number-${index}`"
                            v-model="row.customNumber"
                            :state="errors.length > 0 ? false : null"
                            type="number"
                            :placeholder="$t('DEBTIA_ADD_CUSTOM_NUMBER')"
                          />
                          <small
                            class="text-danger"
                            style="min-height: 18px;"
                          >
                            {{ errors[0] }}
                          </small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>

                <b-form-group class="text-center">
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon rounded-circle"
                    @click.prevent="addRow"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                </b-form-group>
              </b-overlay>

              <b-button
                class="w-100"
                variant="primary"
                type="submit"
                :disabled="invalid || busy"
                @click.prevent="submitForm"
              >
                {{ $t('DEBTIA_ADD_MODULE') }}
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCard,
  BFormInput,
  BOverlay,
  BFormCheckbox,
  BAlert,
} from 'bootstrap-vue'
import axios from '@axios'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { min_value } from 'vee-validate/dist/rules'

extend('min_value', min_value)

export default {
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BCard,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BOverlay,
    BFormCheckbox,
    BAlert,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isTimed: null,
      numberOfDays: null,
      conditionRows: [],
      nextRowId: 1,
      fileCategories: [],
      operatorOptions: [
        { label: '=', value: 3 },
        { label: '!=', value: 4 },
        { label: '>', value: 7 },
        { label: '<', value: 8 },
        { label: '>=', value: 9 },
        { label: '<=', value: 10 },
      ],
      busy: false,
      customVariableOptions: [],
      errorMsg: null,
      min_value,
    }
  },
  created() {
    this.conditionRows.push(this.createEmptyRow())
    this.getFileCategories()
    this.getCustomFieldLabel()
  },
  methods: {
    createEmptyRow() {
      const row = {
        id: this.nextRowId,
        fileCategory: '',
        operator: '',
        customField: '',
        customNumber: '',
      }
      this.nextRowId += 1
      return row
    },
    addRow() {
      this.conditionRows.push(this.createEmptyRow())
    },
    removeRow(index) {
      if (this.conditionRows.length === 1) {
        return
      }
      this.conditionRows.splice(index, 1)
    },
    async getFileCategories() {
      await axios.get('/settings/file-categories-dropdown').then(response => {
        if (response.status === 200) {
          this.fileCategories.push(...response.data.data)
        }
      }).catch(error => console.log(error))
    },
    getCustomFieldLabel() {
      axios.get('/get-all-custom-vars').then(response => {
        if (response.status === 200) {
          const customVariableOptions = response.data.data.filter(item => item.var_for === 'case' && item.var_type === 'number')
          this.customVariableOptions = [
            { label: 'Add custom number', value: 'literal' },
            ...customVariableOptions,
          ]
          return customVariableOptions ? customVariableOptions.label : ''
        }
        return null
      }).catch(error => console.log(error))
    },
    availableFileCategories(index) {
      const selectedElsewhere = this.conditionRows
        .filter((row, i) => i !== index && row.fileCategory !== '')
        .map(row => row.fileCategory)

      return this.fileCategories.filter(
        option => !selectedElsewhere.includes(option.value),
      )
    },
    submitForm() {
      this.busy = true
      this.$refs.docContentRules.validate().then(success => {
        if (success) {
          const processID = this.$route.params.id
          const dataObj = {
            process_id: Number(processID),
            module_id: 25,
            module_order: 1,
            is_timed: this.isTimed,
            days: this.isTimed ? Number(this.numberOfDays) : null,
            conditions: this.conditionRows.map(row => ({
              file_category_id: row.fileCategory !== '' ? row.fileCategory : 0,
              condition_operator_id: row.operator,
              value_type: row.customField === 'literal' ? 'literal' : 'custom_variable',
              literal_value: row.customField === 'literal' ? row.customNumber : null,
              custom_variable_id: row.customField !== 'literal' ? row.customField : null,
            })),
          }
          if (this.conditionObject.moduleID > 0) {
            dataObj.depends_on = this.conditionObject.moduleID
            dataObj.condition = this.conditionObject.type
          }
          axios.post('/process/module/add', dataObj).then(response => {
            if (response.status === 200) {
              this.isTimed = false
              this.numberOfDays = ''
              this.conditionRows = [this.createEmptyRow()]
              const returnObj = {
                parentID: this.conditionObject.parentID,
                depend: dataObj.depends_on,
              }
              returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
              this.$emit('closeContentConditionModal', returnObj)
            }
            this.busy = false
          }).catch(error => {
            this.busy = false
            this.errorMsg = Array.isArray(error.response.data.message)
              ? error.response.data.message[0]
              : error.response.data.message
          })
        } else {
          this.busy = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.condition-row {
  .v-select {
    width: 100%;
    min-width: 0;

    .vs__dropdown-toggle {
      width: 100%;
      flex-wrap: nowrap;
    }

    .vs__selected {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: calc(100% - 30px);
      display: block;
    }

     .vs__dropdown-option--selected::after {
      display: none;
    }

    .vs__selected-options {
      flex-wrap: nowrap;
      overflow: hidden;
      min-width: 0;
    }

    .vs__dropdown-option {
      white-space: normal;
      word-break: break-word;
    }
  }
}
</style>
